import { render, staticRenderFns } from "./QuotaholdersOperationsForm.vue?vue&type=template&id=59863c1f&"
import script from "./QuotaholdersOperationsForm.vue?vue&type=script&lang=js&"
export * from "./QuotaholdersOperationsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports